// 
import WebComponent from '../webComponents/WebComponent';
import Glide from '@glidejs/glide';

class Webslider extends WebComponent {
  constructor(props) {
    super(props);
    this.webslider = null;
    this.websliderVideos = null;
    this.hasVideo = false;
    this.lazyLoadImages = this.lazyLoadImages.bind(this);
    this.pauseVideo = this.pauseVideo.bind(this);
  }

  didMount() {
    const {
      lazyload,
    } = this.props;

    this.websliderVideos = this.element.querySelectorAll('.webslider__video');
    this.hasVideo = this.websliderVideos.length > 0;

    if (lazyload !== false) {
      this.lazyLoadImages();
    }

    this.webslider = new Glide(this.element, this.props).mount();

    if (this.hasVideo) {
      this.webslider.on('run.before', () => {
        this.pauseVideo(this.webslider.index);
     });
    }
  }

  willUnMount() {
    this.webslider.destroy();
  }

  /**
   * Lazy load images from data attributes
   */
  lazyLoadImages() {
    const imageSrc = this.element.querySelectorAll('.webslider__image-wrapper [data-src], .webslider__image-wrapper [data-srcset]');
    let item, dataSrc, dataSrcset;

    for (let index in imageSrc) {
      if (imageSrc.hasOwnProperty(index)) {
        item = imageSrc[index];
        dataSrc = item.getAttribute('data-src');
        dataSrcset = item.getAttribute('data-srcset');
        if (dataSrc) {
          item.setAttribute('src', dataSrc);
        }
        if (dataSrcset) {
          item.setAttribute('srcset', dataSrcset)
        }
      }
    }
  }

  /**
   * pause YT video
   * @param videoIndex
   */
  pauseVideo(videoIndex) {
    const video = document.querySelector('.webslider__slide--active #webslider__video--' + videoIndex);
    const command = window.JSON.stringify({event: 'command', func: 'pauseVideo'});
    if (video) {
      video.contentWindow.postMessage(command, '*');
    }
  }
}

Webslider.defaultProps = {
  type: 'slider',
  lazyload: true,
  startAt: 0,
  perView: 1,
  focusAt: 0,
  gap: 0,
  autoplay: 4000,
  hoverpause: true,
  keyboard: true,
  bound: true,
  swipeThreshold: 80,
  dragThreshold: 120,
  perTouch: false,
  touchRatio: 0.5,
  touchAngle: 45,
  animationDuration: 400,
  rewind: true,
  rewindDuration: 800,
  animationTimingFunc: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
  direction: 'ltr',
  peek: 0,
  throttle: 25,
  breakpoint: {},
  classes: {
    direction: {
      ltr: 'webslider--ltr',
      rtl: 'webslider--rtl'
    },
    slider: 'webslider--slider',
    carousel: 'webslider--carousel',
    swipeable: 'webslider--swipeable',
    dragging: 'webslider--dragging',
    cloneSlide: 'webslider__slide--clone',
    activeNav: 'webslider__bullet--active',
    activeSlide: 'webslider__slide--active',
    disabledArrow: 'webslider__arrow--disabled'
  }
}

export default Webslider;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/Webslider.js